<template>
  <div>
    <section class="section1">
      <!-- <div class="stitle">
        {{detail[0].strategy_title_cn}}
      </div>
      <div class="idea">
        {{detail[0].strategy_content_cn}}
      </div>
      <div>
        <img
          v-for="(item,i) of detail[0].imgList"
          :key="i"
          class="img"
          :src="item"
          alt=""
        >
      </div> -->
       <div v-html="detail.strategy_content_cn">

      </div>
    </section>
    <!-- <section class="section2">
      <div class="text">
        <div class="position">
          <p class="name"> {{detail[1].strategy_title_cn}}</p>
          <div class="conP">
            {{detail[1].strategy_content_cn}}

          </div>
        </div>
      </div>
      <img
        v-for="(item,i) of detail[1].imgList"
        :key="i"
        class="img"
        :src="item"
        alt=""
      >
    </section> -->
  </div>
</template>
<script>
import { Strategy } from "../../api/home";
export default {
  data() {
    return {
      detail: [{ imgList: [] }, { imgList: [] }, { imgList: [] }]
    };
  },
  created() {
    Strategy({
      strategy_type: 3
    }).then(res => {
      // console.log(res.data);
      this.detail = res.data;
    });
  }
};
</script>
<style lang="scss" scoped>
@import "../../assets/custom/common.scss";
.section1 {
  // width: px2Rem(1300);
  margin: auto;
  margin-top: px2Rem(60px);
  margin-bottom: px2Rem(40px);
  .stitle {
    margin-bottom: px2Rem(20px);
    font-size: px2Rem(40px);
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
  }
  .idea {
    margin-bottom: px2Rem(40px);
    font-size: px2Rem(24px);
    font-weight: 400;
    color: #606060;
    line-height: px2Rem(40px);
  }
  .img {
    display: inline-block;
    width: px2Rem(420px);
    height: px2Rem(276px);
    margin-right: px2Rem(19px);
    margin-bottom: px2Rem(20px);
    &:nth-of-type(3n) {
      margin-right: 0;
    }
  }
}
.section2 {
  width: px2Rem(1300px);
  margin: auto;
  // margin-top: px2Rem(60px);
  margin-bottom: px2Rem(40px);
  font-size: 0;
  .text {
    display: inline-block;
    position: relative;
    width: px2Rem(640px);
    min-height: px2Rem(420px);
    .position {
      // position: absolute;
      // top: 50%;
      // transform: translate(0, -50%);
      .name {
        margin-bottom: px2Rem(30px);
        font-size: px2Rem(40px);
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }
      .conP {
        font-size: px2Rem(24px);
        font-weight: 400;
        color: #606060;
        line-height: px2Rem(36px);
      }
    }
  }
  .img {
    display: inline-block;
    width: px2Rem(640px);
    height: px2Rem(420px);
    margin-bottom: px2Rem(20px);
    vertical-align: top;
    &:nth-of-type(2n-1) {
      margin-left: px2Rem(18px);
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/SchoolStrategy/Advantage.vue